import { showDate } from '@libs/NwMoment';

import { normalizeUpdateRequestStatus } from './contactDetails-externalAccess.helpers';

const getApiErrorMessage = (error) => {
    if (!error) {
        return 'unexpected error';
    }
    if (typeof error === 'string') {
        return error;
    }
    if (error.message) {
        return error.message;
    }
    if (error.errorCode) {
        return `${error.errorCode}`;
    }
    return 'unexpected error';
};

const formatUpdateRequestStatus = (status) => {
    const normalizedStatus = normalizeUpdateRequestStatus(status);

    switch (normalizedStatus) {
        case 'draft':
            return 'draft';
        case 'submittedtobooker':
            return 'submitted to booker';
        case 'imported':
            return 'imported';
        case 'importedbybooker':
            return 'imported by booker';
        default:
            return normalizedStatus || '-';
    }
};

const getUpdateRequestStatusBadge = (status) => {
    const normalizedStatus = normalizeUpdateRequestStatus(status);

    switch (normalizedStatus) {
        case 'imported':
        case 'importedbybooker':
            return { label: 'imported', className: 'request-imported' };
        case 'submittedtobooker':
            return { label: 'pending', className: 'request-pending' };
        case 'draft':
            return { label: 'sent', className: 'request-sent' };
        default:
            return normalizedStatus ? { label: formatUpdateRequestStatus(status), className: 'inactive' } : null;
    }
};

const formatDateWithActor = (date, actorName = '') => {
    if (!date) {
        return '-';
    }

    return actorName ? `${showDate(date)} by ${actorName}` : showDate(date);
};

const parseConnectionsEmails = (response) => {
    const payload = Array.isArray(response?.Data) ? response.Data : response?.Data || response;
    const source = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.Items)
          ? payload.Items
          : Array.isArray(response?.Items)
            ? response.Items
            : [];
    const allEmails = source.map((item) => item?.Email).filter(Boolean);
    return [...new Set(allEmails)];
};

const findAvailableEmail = (emails, targetEmail) => {
    if (!targetEmail) {
        return '';
    }

    const normalizedTargetEmail = `${targetEmail}`.trim().toLowerCase();
    return emails.find((email) => email.toLowerCase() === normalizedTargetEmail) || '';
};

const getInitialSelectedEmail = (emails, currentAccessEmail = '', defaultContactEmail = '') => {
    const currentAccessSelectedEmail = findAvailableEmail(emails, currentAccessEmail);
    if (currentAccessSelectedEmail) {
        return currentAccessSelectedEmail;
    }

    if (currentAccessEmail) {
        return '';
    }

    const defaultEmail = findAvailableEmail(emails, defaultContactEmail);
    if (defaultEmail) {
        return defaultEmail;
    }

    return emails[0] || '';
};

const buildUpdateRequestEmailBody = (updateFormUrl) => {
    if (!updateFormUrl) {
        return '';
    }

    return [
        'Hello,',
        '',
        'Please use the link below to review and update your model data.',
        '',
        updateFormUrl,
        '',
        'Thank you.',
    ].join('\n');
};

const buildUpdateRequestEmailHref = ({ recipientEmail, updateFormUrl }) => {
    const normalizedRecipientEmail = `${recipientEmail || ''}`.trim();
    const body = buildUpdateRequestEmailBody(updateFormUrl);

    if (!normalizedRecipientEmail || !body) {
        return '';
    }

    return `mailto:${normalizedRecipientEmail}?subject=${encodeURIComponent(
        'Data Update Request'
    )}&body=${encodeURIComponent(body)}`;
};

export {
    buildUpdateRequestEmailHref,
    formatDateWithActor,
    getApiErrorMessage,
    getInitialSelectedEmail,
    getUpdateRequestStatusBadge,
    parseConnectionsEmails,
};
